import { Float } from "@react-three/drei";
import { Fog } from "three";
import { useMemo } from "react";
import type { DeviceCapability, QualityPreset } from "../lib/3d/sceneTypes";
import { CameraRig } from "./CameraRig";
import { SceneManager } from "./SceneManager";

type ExperienceProps = {
  capability: DeviceCapability;
  quality: QualityPreset;
};

export function Experience({ capability, quality }: ExperienceProps) {
  const fog = useMemo(() => new Fog("#b8b6b5", 8, capability.prefersReducedMotion ? 16 : 19), [capability.prefersReducedMotion]);

  return (
    <>
      <primitive attach="fog" object={fog} />
      <ambientLight intensity={quality === "low" ? 0.92 : 1.04} />
      <hemisphereLight args={["#ebe8e6", "#8e8b89", quality === "low" ? 0.96 : 1.08]} />
      <directionalLight color="#f4f1ef" intensity={quality === "low" ? 1.12 : 1.34} position={[-3.8, 4.8, 4.4]} />
      <directionalLight color="#c9c6c4" intensity={quality === "low" ? 0.62 : 0.78} position={[4.4, 2.8, 2.4]} />
      <pointLight color="#f7f4f1" intensity={quality === "low" ? 0.22 : 0.32} distance={12} position={[0, 2.6, 3.2]} />
      {/* <Float
        enabled={!capability.prefersReducedMotion}
        floatIntensity={quality === "low" ? 0.12 : 0.22}
        rotationIntensity={0.5}
        speed={1}
      >
      </Float> */}
      <SceneManager />
      <CameraRig />
    </>
  );
}
